import React, { FunctionComponent, SVGProps, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import BaseButton from 'features/app/components/BaseButton';
import { useTranslation } from 'hooks/useTranslation';

import { useStyles } from './styles';
import { useDispatch } from 'react-redux';
import { editProfileRequest } from 'features/user/api';
import { profileSuccess } from 'features/user/redux/actions';
import useAuth from 'features/auth/hooks/useAuth';
import { useHistory } from 'react-router-dom';
import { dashboardPaths } from 'features/dashboard/routes/paths';

interface SuccessfulActionProps {
  onSuccessfulAction?: () => void;
  variant?: 'bulk' | 'single';
  title?: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement> & { title?: string | undefined }>;
}

export const SuccessfulAction = ({
  onSuccessfulAction,
  variant = 'single',
  title,
  icon: Icon,
}: SuccessfulActionProps) => {
  const { t } = useTranslation('dashboard');
  const classes = useStyles();
  const dispatch = useDispatch();
  const { user } = useAuth();
  const history = useHistory();
  const text = variant === 'single' ? t('giftSentSuccessfully') : t('onProcessBulkOrderMessage');

  useEffect(() => onSuccessfulAction, [onSuccessfulAction]);

  const backToDashboard = async () => {
    if (user?.show_started_tips) {
      const response = await editProfileRequest({ show_started_tips: false });
      dispatch(profileSuccess(response.data));
    }
    history.push(dashboardPaths.static.root);
  };

  return (
    <Box flex={1} display="flex" justifyContent="center" alignItems="center">
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        className={classes.modalContainer}
      >
        <Box display="flex" justifyContent="center" alignItems="center" className={classes.planeIconContainer}>
          <Icon />
        </Box>
        <Typography variant="h3" className={classes.modalTitle}>
          {title ?? text}
        </Typography>
        <BaseButton borderRadius={13} className={classes.backToDashboardBtn} onClick={backToDashboard}>
          {t('backToDashboard')}
        </BaseButton>
      </Box>
    </Box>
  );
};
